globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Controllers = appCustomerSpace.Controllers || {};
appCustomerSpace.Controllers.Reviews = appCustomerSpace.Controllers.Reviews || {};

appCustomerSpace.Controllers.Reviews.RequestsController = (function(superClass) {

  utils.extend(RequestsController, superClass);

  function RequestsController() {
    return RequestsController.__super__.constructor.apply(this, arguments);
  }

  $.extend(RequestsController.prototype, {
    init: function(){
      this.initEvents();

      return RequestsController.__super__.init.apply(this, arguments);
    },
    initEvents: function(){
      var controller = this;

      $(".recipient-consent-checkbox").on('change', function() {
        if ($(this).is(':checked')) {
          $('.btn-disabled-true').hide();
          $('.btn-disabled-false').show();
        } else {
          $('.btn-disabled-true').show();
          $('.btn-disabled-false').hide();
        }
      });

      $(".recipient-consent-checkbox").on('change', function() {
        var $checkbox = $(this);
        var $dataValidationCheckboxContainer = $('.data-validation-checkbox-container');
        if(!$dataValidationCheckboxContainer.hasClass('needs-verification') || ($dataValidationCheckboxContainer.hasClass('needs-verification') && $dataValidationCheckboxContainer.find('.data-validation-checkbox').is(':checked'))){
          if ($checkbox.is(':checked')) {
            $('.btn-disabled-true').hide();
            $('.btn-disabled-false').show();
          } else {
            $('.btn-disabled-true').show();
            $('.btn-disabled-false').hide();
          }
        } else {
          $('.btn-disabled-true').show();
          $('.btn-disabled-false').hide();
        }
      });

      $('.data-validation-checkbox').on('change', function(){
        var $checkbox = $(this);
        var $recipientConsentCheckbox = $('.recipient-consent-checkbox');
        if($recipientConsentCheckbox.is(':checked')){
          if ($checkbox.is(':checked')) {
            $('.btn-disabled-true').hide();
            $('.btn-disabled-false').show();
          } else {
            $('.btn-disabled-true').show();
            $('.btn-disabled-false').hide();
          }
        } else {
          $('.btn-disabled-true').show();
          $('.btn-disabled-false').hide();
        }
      })

      $(".request-text-message-content").on('input', function() {
        var $smsCharactersCount = $('#sms-characters-count');

        $smsCharactersCount.text(this.value.length);
        controller.toggleCharactersLimitError($smsCharactersCount);
      });

      $(".request-email-body").on('input', function() {
        var $emailCharactersCount = $('#email-characters-count');

        $emailCharactersCount.text(this.value.length);
        controller.toggleCharactersLimitError($emailCharactersCount);
      });

      $('body').find('.recipients-container').on('change', '.select-contact-checkbox', function(){
        var count = $(".recipients-container").find('.select-contact-checkbox').filter(':checked').length
        $('#multiple-reviews-requests-contacts-count').html(count);
        if(count > 1){
          $('.sending-button-text').html("Envoyer les invitations");
        } else {
          $('.sending-button-text').html("Envoyer l'invitation");
        }
        if(count > 50){
          $('.too-many-contacts-alert').show();
        } else {
          $('.too-many-contacts-alert').hide();
        }

        if($(this).is(':checked')){
          $(this).closest('tr').find('input.form-control').each(function(){ $(this).prop('disabled', false) })
        } else {
          $(this).closest('tr').find('input.form-control').each(function(){ $(this).prop('disabled', true) })
        }
      });

      $('.revalidate-template').on('change', function(){
        controller.loadRequestTemplate();
      });

      $("input[type='radio']").each(function() {
        var $externalLinkSelect = $("#external_link");
        var $noWebsiteSelectedAlert = $('.no-website-selected-alert');

        $(this).on('change', function() {
          if ($(this).is(':checked')) {
            if ($(this).val() == "external_link") {
              $externalLinkSelect.show();
            } else {
              $externalLinkSelect.hide();
            }
            if ($(this).val() == "website" && $noWebsiteSelectedAlert.length > 0) {
              $noWebsiteSelectedAlert.show();
            } else {
              $noWebsiteSelectedAlert.hide();
            }
          }
        })
      });

      $('.advanced-options-default-targeted-platform-type-input').on('change', function(){
        $('.targeted-platform-type-input').val($(this).val()).trigger('change');
      });

      $('.advanced-options-default-external-link-input').on('change', function(){
        $('.form-external-link-input').val($(this).val()).trigger('change');
      });

      $('.advanced-options-default-text-message-sender-name-input').on('change', function(){
        var value = $(this).val();
        var regex = /^[a-zA-Z0-9\s]+$/;

        if(value.length <= 11 && regex.test(value) ){
          $(this).closest('.form-group').removeClass('has-error');
          $(this).closest('.form-group').find('.text-message-sender-name-input-errors').hide();
          $('.text-message-sender-name-input').val($(this).val()).trigger('change');
        } else {
          $(this).closest('.form-group').addClass('has-error');
          $(this).closest('.form-group').find('.text-message-sender-name-input-errors').show();
        }
      });

      $('.advanced-options-default-business-owner-name-input').on('change', function(){
        $('.business-owner-name-input').val($(this).val()).trigger('change');
      });

      $('.advanced-options-request-template-id-input').on('change', function(){
        if($(this).val() != '-'){
          $('.request-template-id-input').val($(this).val());
          $('.default-request-template-id-input').val($(this).val());
        } else {
          $('.request-template-id-input').val('');
          $('.default-request-template-id-input').val('');
        }
        controller.loadRequestTemplate();
      });

      $('.open-set-advanced-options-modal').on('click', function(e){
        e.preventDefault();
        appCustomerSpace.Loader().start({
          options: {
            text: false,
            icon_size: '2x',
            spinner: true,
            style: {
              backdrop: {
                background: 'rgba(42, 57, 82, 0.5)',
                backdropFilter: 'blur(3px)'
              },
              spinner: {
                color: '#FFF'
              }
            }
          }
        });
        setTimeout(function(){
          $('.set-advanced-options-modal-backdrop').fadeIn();
          $('.set-advanced-options-modal').fadeIn();
          appCustomerSpace.Loader().stop();
        }, 500);
      });
      $('button[type=close]').on('click', function(e){
        e.preventDefault();
        $('.set-advanced-options-modal').fadeOut();
        $('.set-advanced-options-modal-backdrop').fadeOut();
      });
    },
    loadRequestTemplate: function(templateId, callback){
      var controller                  = this,
          errorMsg                    = 'Erreur de chargement du modèle',
          $form                       = $('.new-review-request-form'),
          $emailSubject               = $form.find('.request-email-subject'),
          $emailBody                  = $form.find('.request-email-body'),
          $textMessageContent         = $form.find('.request-text-message-content'),
          $smsCharactersCount         = $form.find('#sms-characters-count'),
          $emailCharactersCount       = $form.find('#email-characters-count'),
          recipientName               = $form.find('#customer_space_reviews_requests_abstract_request_recipient_name').val(),
          businessOwnerName           = $form.find('.business-owner-name-input').val(),
          $requestTemplateIdInput     = $form.find('.request-template-id-input'),
          $templateContent            = $form.find('.template-content');

      if(templateId == undefined) {
        templateId = $requestTemplateIdInput.val() == '' ? undefined : $requestTemplateIdInput.val();
        if(templateId == undefined) return;
      }

      appCustomerSpace.Loader().start({ $container: $templateContent });

      $.ajax({
        type: "GET",
        url: '/avis/collectes/get_request_template_content',
        data: {
          selected_template_id: templateId,
          recipientName: recipientName,
          businessOwnerName: businessOwnerName
        },
        success: function(data) {
          if (data.response == 1) {
            $emailSubject.val(data.request_template_email_subject);
            $emailBody.val(data.request_template_email_body);

            $textMessageContent.val(data.request_template_text_message_content);

            if ($smsCharactersCount.length != 0) {
              $smsCharactersCount.text($textMessageContent.val().length);
              controller.toggleCharactersLimitError($smsCharactersCount);
            }

            if ($emailCharactersCount.length != 0) {
              $emailCharactersCount.text($emailBody.val().length);
              controller.toggleCharactersLimitError($emailCharactersCount);
            }

            $requestTemplateIdInput.val(templateId);

            $templateContent.find("textarea").css({height: 'auto'}).css({height: $templateContent.find("textarea")[0].scrollHeight + 'px' });

            appCustomerSpace.Loader().stop({ $container: $templateContent });
            if(typeof callback == 'function') callback();
          } else {
            appCustomerSpace.Loader().stop({ $container: $templateContent });
            alert(errorMsg);
          }
        }
      }).fail(function() {
          alert(errorMsg);
      });
    },
    toggleCharactersLimitError: function($counter) {
      if (parseInt($counter.text()) > $counter.data('max-characters-count')) {
        $counter.parent().css('color', 'red');
        $('.caracters-number-limit-alert').show();
        $('.btn-disabled-false').attr('disabled','disabled');
      } else {
        $counter.parent().css('color', '');
        $('.caracters-number-limit-alert').hide();
        $('.btn-disabled-false').removeAttr('disabled');
      }
    }
  });

  return RequestsController;

})(appCustomerSpace.Controllers.Reviews.MainController);
